import * as React from 'react';
import { grey,red} from '@mui/material/colors';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Snackbar,Alert,IconButton,
  Modal, Typography, Box, Backdrop, FormHelperText, Fade, 
  ListItemText, Button, FormControl, TextField, MenuItem, 
  Select, InputAdornment, CircularProgress 
} from "@mui/material";
import { useState, useEffect } from "react";
import AddIcon from '@mui/icons-material/Add';
import ErrorIcon from '@mui/icons-material/Error';
import BASE_URL from '../../config';

const style = {
  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
  width: { xs: '90%', sm: '500px' }, height: 'auto', bgcolor: 'background.paper',
  boxShadow: 24, borderRadius: 4, p: 4, overflowY: 'auto', outline: 'none',
};

const Inputstyle = {
  '& .MuiOutlinedInput-root': {
    bgcolor: '#f5f5f5', borderRadius: '8px',
    '& fieldset': { borderColor: 'transparent' },
    '&:hover fieldset': { borderColor: grey[400] },
    '&.Mui-focused fieldset': { borderColor: grey[600] },
  },
};

export default function TransitionsModal({refresh }) {
  const [showPassword, setShowPassword] = useState(false);
  const [open, setOpen] = useState(false);
  const [rolesDB, setRolesDB] = useState([]);
  const [error, setError] = useState('');
  const [showErrors, setShowErrors] = useState(false);
  const [loading, setLoading] = useState(false); 
  const [confirmType, setConfirmType] = useState(null); 

  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  const [user, setUser] = useState({
    nombre_completo: '', email: '', user_pass: '', phone: '', role: '', estado: ''
  });

  // Validaciones
  const isUsenameValid = user.nombre_completo.trim().length > 6;
  const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(user.email);
  const isPhoneValid = user.phone.length === 10;
  const isPassValid = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(user.user_pass);
  const isFormComplete = isUsenameValid && isEmailValid && isPassValid && isPhoneValid && user.role !== '' && user.estado !== '';
  
    useEffect(() => {
      if (open) {
        fetch(`${BASE_URL}/roles`)
          .then(res => res.json())
          .then(data => setRolesDB(data))
          .catch(() => setSnackbar({ open: true, message: 'No se pudieron cargar los roles', severity: 'error' }));
      }
    }, [open]);

    useEffect(() => {
      if (open) {
        setUser({
          nombre_completo:'',
          email:'',
          phone:'',
          user_pass:'',
          role:'',
          estado:''
        });
        setShowErrors(false);
        setConfirmType(null);
        setError('');
      }
      
    }, [open]);

  const handleChange = (e) => {
  const { name, value } = e.target;

    // 1. Definimos los límites específicos
  const limits = {
    nombre_completo: 35,
    email: 30,
    user_pass:20
  
  };

    if (limits[name] && value.length > limits[name]) {
      return;
    }

    if (name === 'phone') {
      const onlyNums = value.replace(/[^0-9]/g, '');
      if (onlyNums.length <= 10) setUser({ ...user, [name]: onlyNums });
      return;
    }
    if (name === 'nombre_completo') {
    const onlyLetters = value.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑ ]/g, '');
    setUser({ ...user, [name]: onlyLetters });
    return;
  }
    setUser({ ...user, [name]: value });
  };

  

  const handleClose = () => {
    setConfirmType(null);
    setLoading(false);
    setError('');
    setUser({
      nombre_completo: '',
      email: '',
      phone: '',
      user_pass: '',
      role: '',
      estado: ''
    });
    setShowErrors(false);
    setOpen(false);
  };

  const handleAuth = async () => {
    setLoading(true);
    setError('');

    try {
      const res = await fetch(`${BASE_URL}/users/newuser`, {
        method: 'POST',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(user),
      });
      const data = await res.json();
      
      if (res.ok) {
        setSnackbar({ open: true, message: 'Usuario creado con éxito', severity: 'success' });
        setTimeout(() => {
          if(refresh) refresh();
          handleClose();
        }, 1200); 
      } else {
        setError(data.message || 'Error al registrar el usuario.');
        setConfirmType(null); // Regresa al formulario si falla
        setLoading(false);
      }
    } catch (e) {
      setError('Error de conexión con el servidor.');
      setConfirmType(null);
      setLoading(false);
    }
  };

  const validateAndConfirm = async () => {
    setShowErrors(true);
    setError('');

    if (!isFormComplete) return;

    setLoading(true);
    try {
      // Reutilizamos el endpoint de checkmail. Al ser un usuario nuevo, mandamos userId 0 o null
      const res = await fetch(`${BASE_URL}/users/checkmail`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ 
            email: user.email, 
            userId: 0 // Indica que es un nuevo registro
        })
      });

      const data = await res.json();

      if (res.ok) {
        // Si el correo está libre, mostramos la confirmación
        setConfirmType('save');
      } else {
        // Si ya existe, mostramos el error en el formulario actual
        setError(data.message || 'El correo ya está registrado.');
      }
    } catch (e) {
      setError('Error al validar los datos.');
    } finally {
      setLoading(false);
    }
  };

    const ConfirmView = () => (
      <Box sx={style}>
        <Typography variant="h6">
          {confirmType === 'cancel' ? '¿Cancelar edición?' : '¿Guardar cambios?'}
        </Typography>
        <Typography variant="body1" color='textSecondary' sx={{ mt: 1, mb: 3 }}>
          {confirmType === 'cancel' 
            ? '¿Estás seguro que deseas cancelar? Los cambios realizados se perderán.' 
            : '¿Estás seguro que deseas crear este nuevo usuario?'}
        </Typography>
        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'end' }}>
          <Button 
            variant="contained" 
            sx={{ bgcolor: grey[200], color: 'black', textTransform: 'none', px: 3, borderRadius: '8px'}} 
            onClick={() => setConfirmType(null)}
            disabled={loading}
          >
            {confirmType === 'cancel' ? 'No, continuar' : 'No, revisar'}
          </Button>
          <Button 
            variant="contained" 
            sx={{ bgcolor: 'black', color: 'white', textTransform: 'none', px: 3, borderRadius: '8px'}}
            onClick={confirmType === 'cancel' ? () => setOpen(false) : handleAuth}
            disabled={loading}
          >
            {loading ? <CircularProgress size={20} color="inherit" /> : (confirmType === 'cancel' ? 'Sí, cancelar' : 'Sí, guardar')}
          </Button>
        </Box>
      </Box>
    );

  return (
    <Box>
      <Button fullWidth onClick={() => setOpen(true)} sx={{borderRadius: '8px', bgcolor: 'black', textTransform:'none' }} variant="contained"  startIcon={<AddIcon />}>
        Nuevo usuario
      </Button>

      <Modal open={open} onClose={handleClose} closeAfterTransition slots={{ backdrop: Backdrop }}>
        <Fade in={open}>
          <Box>
          {confirmType ? <ConfirmView /> : (
          <Box sx={style}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Typography variant="h6">Nuevo Usuario</Typography>
              <Typography variant="body1" sx={{ color: grey[600], mb: 2 }}>Completa la información</Typography>

              {/* Mensaje de error de base de datos */}
              {error && (
                <Box sx={{ bgcolor: red[50], p: 1.5, borderRadius: '8px', mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                  <ErrorIcon sx={{ color: red[700], fontSize: 20 }} />
                  <Typography sx={{ color: red[700], fontSize: '0.875rem', fontWeight: 500 }}>{error}</Typography>
                </Box>
              )}

              <Box style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
                
                {/* Nombre */}
                <FormControl error={showErrors && !isUsenameValid} sx={{ mb: 1 }}>
                  <Typography sx={{ mb: 0.5 }}>Nombre Completo</Typography>
                  <TextField 
                    size="small" sx={Inputstyle} fullWidth name='nombre_completo' onChange={handleChange} value={user.nombre_completo}
                    error={(user.nombre_completo.length > 0 && !isUsenameValid) || (showErrors && user.nombre_completo === '')}
                    helperText={user.nombre_completo.length > 0 && !isUsenameValid ? "Ingresa tu nombre completo" : (showErrors && user.nombre_completo === '' ? "Campo obligatorio" : "")}
                  />
                </FormControl>

                {/* Email */}
                <FormControl error={showErrors && !isEmailValid} sx={{ mb: 1 }}>
                  <Typography sx={{ mb: 0.5 }}>Correo Electrónico</Typography>
                  <TextField 
                    size="small" sx={Inputstyle} fullWidth name='email' onChange={handleChange} value={user.email}
                    error={(user.email.length > 0 && !isEmailValid) || (showErrors && user.email === '')}
                    helperText={user.email.length > 0 && !isEmailValid ? "Ingresa un correo válido" : (showErrors && user.user_pass === '' ? "Campo obligatorio" : "")}

                  />
                </FormControl>

                {/* Contraseña */}
                <FormControl 
                    error={(user.user_pass.length > 0 && !isPassValid) || (showErrors && user.user_pass === '')} 
                    sx={{ mb: 1 }} 
                  > 
                  <Typography sx={{ mb: 0.5 }}>Contraseña</Typography>
                  <TextField 
                  // 1. Mantenemos el cambio de tipo dinámico
                  type={showPassword ? 'text' : 'password'} 
                  size="small" 
                  fullWidth 
                  name='user_pass' 
                  onChange={handleChange} 
                  value={user.user_pass}
                  
                  // 2. Quitamos el icono nativo de los navegadores (como Edge o Chrome en algunas versiones)
                  sx={{ 
                    ...Inputstyle, // Mantenemos tus estilos previos
                    '& input::-ms-reveal': { display: 'none' }, 
                    '& input::-ms-clear': { display: 'none' },
                  }}

                  error={(user.user_pass.length > 0 && !isPassValid) || (showErrors && user.user_pass === '')}
                  helperText={
                    user.user_pass.length > 0 && !isPassValid 
                      ? "Mínimo 8 caracteres, 1 mayúscula y 1 número" 
                      : (showErrors && user.user_pass === '' ? "Campo obligatorio" : "")
                  }

                  // 3. Verificamos que InputProps esté bien formado
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end">
                          {showPassword ? <VisibilityOff fontSize="medium" /> : <Visibility fontSize="medium" />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  />
                </FormControl>

                {/* Teléfono */}
                <FormControl error={showErrors > 0 && !isPhoneValid} sx={{ mb: 1 }}>
                  <Typography sx={{ mb: 0.5 }}>Teléfono</Typography>
                  <TextField 
                    size="small" sx={Inputstyle} fullWidth name='phone' onChange={handleChange} value={user.phone}
                    error={(user.phone.length > 0 && !isPhoneValid) || (showErrors && user.phone.length === 0)}
                    helperText={(user.phone.length > 0 && !isPhoneValid) || (showErrors && user.phone.length === 0) ? "Se requieren 10 dígitos" : ""}
                    InputProps={{ startAdornment: <InputAdornment position="start">+52</InputAdornment> }}
                  />
                </FormControl>

                {/* Rol */}
                <FormControl error={showErrors && user.role === ''} sx={{ mb: 1 }}>
                  <Typography sx={{ mb: 0.5 }}>Rol</Typography>
                  <Select name='role' size='small' displayEmpty value={user.role} onChange={handleChange} sx={Inputstyle} fullWidth>
                    <MenuItem disabled value="">Seleccionar Rol</MenuItem>
                    {rolesDB.map((rol) => (<MenuItem key={rol.id} value={rol.nombre}><ListItemText primary={rol.nombre} /></MenuItem>))}
                  </Select>
                  {showErrors && user.role === '' && <FormHelperText sx={{ color: red[700] }}>Campo requerido</FormHelperText>}
                </FormControl>

                {/* Estado */}
                <FormControl error={showErrors && user.estado === ''} sx={{ mb: 1 }}>
                  <Typography sx={{ mb: 0.5 }}>Estado</Typography>
                  <Select name='estado' size='small' displayEmpty value={user.estado} onChange={handleChange} sx={Inputstyle} fullWidth>
                    <MenuItem disabled value="">Seleccionar una opción</MenuItem>
                    {[true, false].map((status) => (<MenuItem key={status.toString()} value={status}><ListItemText primary={status ? "Activo" : "Inactivo"} /></MenuItem>))}
                  </Select>
                  {showErrors && user.estado === '' && <FormHelperText sx={{ color: red[700] }}>Campo requerido</FormHelperText>}
                </FormControl>

                {/* Botones */}
                <Box sx={{ display: 'flex', mt: 2, justifyContent: 'end', gap: 2 }}>
                  <Button 
                    onClick={() => setConfirmType('cancel')} 
                    sx={{ bgcolor: grey[200], 
                          color: 'black', 
                          textTransform: 'none',
                          width: { xs: '50%', sm: '25%' },
                          px:3}}
                  >
                    Cancelar
                  </Button>
                  <Button 
                    variant='contained' 
                    onClick={validateAndConfirm} 
                    disabled={loading} 
                    sx={{ 
                      textTransform: 'none',
                      bgcolor: 'black', 
                      width: { xs: '50%', sm: '30%' }
                    }}
                  >
                    {loading ? <CircularProgress size={24} sx={{ color: 'white' }} /> : "Crear cuenta"}
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
          )}
          </Box>
        </Fade>
      </Modal>
      <Snackbar 
        open={snackbar.open} 
        autoHideDuration={4000} 
        onClose={() => setSnackbar({...snackbar, open: false})} 
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert severity={snackbar.severity} variant="filled" sx={{ width: '100%', borderRadius: '10px' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}